import React, { Component } from 'react'
import Button from 'react-bootstrap/Button'
import Modal from './Modal'
import { extendParentClass, extendBaseClass } from '../../../../utils/classes'

export class Credits extends Component {
  state = {
    showCredits: false,
  }

  setShowCredits = (showCredits) => this.setState({ showCredits })

  handleClick = () => this.setShowCredits(true)

  baseClass = extendParentClass.bind(this)('credits')

  extend = extendBaseClass.bind(this)

  render() {
    const { showCredits } = this.state
    return (
      <>
        <Button
          variant="link"
          onClick={this.handleClick}
          className={this.extend('show-credits')}
        >
          Credits
        </Button>
        <Modal setShowCredits={this.setShowCredits} showCredits={showCredits} />
      </>
    )
  }
}

export default Credits
